export default ({ app }: any) => {
	// 仅在客户端执行，注册全局路由守卫
	// if (!process.client) return;
	// const router = app.router;
	// if (!router) return;

	// router.beforeEach((to: any, from: any, next: any) => {
	// 	try {
	// 		const hostname = window.location.hostname;
	// 		// 仅当 host 包含 clipfly 且访问首页时才重定向
	// 		const isTargetHost = hostname.includes('clipfly');
	// 		const isHomePath = to.path === '/' || to.path === '';
	// 		if (isTargetHost && isHomePath) {
	// 			const search = window.location.search || '';
	// 			return next(`/mobile/clipfly/downloadApp${search}`);
	// 		}
	// 		return next();
	// 	} catch (e) {
	// 		next();
	// 	}
	// });
};